import React, { useEffect, useState } from 'react'
import MUIDataTable from 'mui-datatables'
import { Loading } from '../../components/Main'
import { generateFilename } from '../../utility/Helpers'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import styles from './ButtonStyles'
import { Download } from '@mui/icons-material'
const WideTable = (data) => {
  const { t } = useTranslation()
  const classes = styles()
  const {
    datatable: dt,
    filename = 'WIDECOMMERZ',
    length = 0,
    onPageChange,
    onPerRowsChange,
    onSortChange,
    paginationDefaultPage,
    paginationPerPage,
    sortOrder,
  } = data
  const [datatable, setDatatable] = useState({})
  useEffect(() => {
    if (dt !== undefined) {
      setDatatable(dt)
    }
  }, [dt])
  const handlePageChange = (page) => {
    onPageChange(page)
  }
  const handlePerRowsChange = async (page) => {
    onPerRowsChange(page)
  }
  const handleSortChange = (columnName, direction) => {
    onSortChange(columnName, direction)
  }
  return (
    <>
      {datatable.data ? (
        <>
          <MUIDataTable
            data={datatable.data}
            columns={datatable.columns}
            selectableRowsHeader={false}
            components={{
              icons: {
                DownloadIcon: () => (
                  <Box
                    className={classes.buttonCustom}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Download fontSize="small" sx={{ marginRight: '8px' }} />
                    {t('button.download')}
                  </Box>
                ),
              },
            }}
            options={{
              serverSide: true,
              selectableRowsHideCheckboxes: true,
              sortOrder: sortOrder,
              onChangePage: (page) => handlePageChange(page),
              onChangeRowsPerPage: (numberOfRows) => handlePerRowsChange(numberOfRows),
              onColumnSortChange: (columnName, direction) =>
                handleSortChange(columnName, direction),
              page: paginationDefaultPage,
              rowsPerPage: paginationPerPage,
              count: length,
              viewColumns: false,
              search: false,
              print: false,
              filter: false,
              downloadOptions: {
                filename: generateFilename(filename, 'csv'),
                separator: ';',
                filterOptions: {
                  useDisplayedColumnsOnly: false,
                  useDisplayedRowsOnly: true,
                },
              },
            }}
          />
        </>
      ) : (
        <>
          <Loading />
        </>
      )}
    </>
  )
}

export default WideTable
